import React from "react";

import Grid from "@mui/material/Grid";

import SearchIcon from "@mui/icons-material/Search";
import EventIcon from "@mui/icons-material/Event";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import Heading from "components/typographies/Heading/Heading.component";
import Label from "components/typographies/Label/Label.component";
import Body from "components/typographies/Body/Body.component";

// Styles
import { useStyles } from "./ContentBoxes.styles";

const infoSectionContents = [
  {
    title: "Bounce ideas, get recommendations!",
    body: "Our expert car-lovers are here to help you find the ideal vehicle for your needs and lifestyle. We can connect you with dealers and book test drives for you - hassle free!",
    icon: <EmojiObjectsOutlinedIcon />,
  },
  {
    title: "Impartial advice",
    body: "We don't work for any car manufacturers or dealerships, so we can offer unbiased advice when recommending vehicles.",
    icon: <InfoOutlinedIcon />,
  },
  {
    title: "Explore our marketplace",
    body: "Get price quotes and compare new car prices from multiple dealerships in your area all at once.",
    icon: <SearchIcon />,
  },
  {
    title: "Completely free",
    body: "Browse the marketplace, or ask our team for help. Either way, it's free.",
    icon: <EventIcon />,
  },
];

const ContentBoxes = () => {
  const classes = useStyles();

  return (
    <div>
      <Heading variant="h4" showSpacer>
        {"You can do everything yourself, but you don't have to"}
      </Heading>
      <Grid container columnSpacing="2px" rowSpacing="10px">
        {infoSectionContents.map((section) => (
          <Grid key={section.title} item xs={12} md={3}>
            <div className={classes.contentBox}>
              {section.icon}
              <Label size="lg" weight="semibold">
                {section.title}
              </Label>
              <Body size="md">{section.body}</Body>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ContentBoxes;
